import IconHolder from '@nile/banyan/src/Components/Public/Utlis/IconHolder';
import AutoComplete from '@nile/banyan/src/Pebbles/autocomplete';
import { processData } from '@nile/banyan/src/Utils/autocomplete';
import {
  PageContent,
  RoleBoxContainer,
  ScrollContent
} from '@nile/banyan/src/Utils/style';
import { Icon, getTranslatedText } from '@nile/components';
import { DeleteModal } from '@nile/components/src';
import {
  Avatar,
  Button,
  ButtonGroup,
  Card,
  FormLayout,
  Heading,
  Link,
  ResourceItem,
  ResourceList,
  TextContainer,
  TextField,
  TextStyle
} from '@shopify/polaris';
import { Edit } from '@styled-icons/material/Edit';
import { SVGIcon } from '@superops/super-icons';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';

class ClientCascade extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inputValue: '',
      value: [],
      selectedClient:
        this.props.techGroups.length > 0 ? this.props.techGroups[0] : null,
      selectedItems:
        props.techGroups.length > 0 ? [props.techGroups[0].accountId] : [],
      uioptions: [
        {
          id: 1,
          name: '',
          uioptions: props.techGroups
        }
      ]
    };
  }

  static getDerivedStateFromProps(props, state) {
    if (
      !props.techGroups.find(
        (group) => group.accountId === state.selectedClient.accountId
      )
    ) {
      return {
        ...state,
        selectedTechGroup: props?.techGroups?.[0],
        selectedItems: ['1']
      };
    }
  }

  renderSubItem = (item) => {
    this.setState({ selectedClient: item });
  };

  deleteClient = (accountId) => {
    this.props.deleteClient({
      variables: { accountId }
    });
  };

  setSelectedItems = (selectedItem) => {
    if (selectedItem.length > 0) {
      this.setState({ selectedItems: [selectedItem[selectedItem.length - 1]] });
    }
  };

  handleClientChange = (selectedItem) => {
    this.setState({ selectedItems: [selectedItem.id] });
    this.renderSubItem(selectedItem);
  };

  render() {
    const { selectedClient, selectedItems } = this.state;

    const { intl } = this.props;

    const { techGroups } = this.props;

    const processedAllItems = processData(techGroups, 'accountId');

    return (
      <div className="Clients-Wrap">
        <Card>
          <PageContent className="fx bshadow">
            <RoleBoxContainer className="fx cascadeContainer">
              <div className="cascade w100">
                <div className="full-width">
                  <div style={{ marginTop: '20px' }}>
                    <AutoComplete
                      options={processedAllItems}
                      handleChange={this.handleClientChange}
                    />
                  </div>
                  <ResourceList
                    items={techGroups}
                    selectedItems={selectedItems}
                    onSelectionChange={this.setSelectedItems}
                    renderItem={(item, index) => {
                      const { accountId, name, technicians, clients } = item;
                      return (
                        <ResourceItem
                          id={accountId}
                          accessibilityLabel={`View details for ${name}`}
                          customClassName="list-no-pad"
                        >
                          <div
                            className="fw list-item"
                            onClick={this.renderSubItem.bind(this, item)}
                          >
                            {!technicians && !clients && (
                              <TextStyle variation="strong">{name} </TextStyle>
                            )}
                          </div>
                          {item.uioptions && item.uioptions.length > 0 ? (
                            <div className="iconHolder">
                              <SVGIcon name="ArrowRight" />
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </ResourceItem>
                      );
                    }}
                  />
                </div>
              </div>
            </RoleBoxContainer>
            {selectedClient && (
              <RoleBoxContainer className="fx cascadeContainer">
                <ScrollContent height={'44vh'} className="m40 full-width">
                  <div className="fx full-width">
                    {selectedClient.userList &&
                      selectedClient.userList.length > 0 && (
                        <div className="fx2">
                          <div className="f-20 mt-14 mb-14"> Technicians </div>
                          <ResourceList
                            items={selectedClient.userList}
                            renderItem={(item) => {
                              const {
                                userId,
                                firstName,
                                lastName,
                                email
                              } = item;
                              const media = (
                                <Avatar
                                  customer
                                  size="medium"
                                  name={firstName}
                                />
                              );

                              return (
                                <ResourceItem
                                  id={userId}
                                  media={media}
                                  accessibilityLabel={`View details for ${firstName} ${lastName}`}
                                >
                                  <h3>
                                    <TextStyle variation="strong">
                                      {firstName} {lastName}
                                    </TextStyle>
                                  </h3>
                                  <div>{email}</div>
                                </ResourceItem>
                              );
                            }}
                          />
                        </div>
                      )}
                    {selectedClient && (
                      <div className="fx2">
                        <TextContainer>
                          <div className="fx actr">
                            <div className="pr14">
                              <Avatar
                                customer
                                size="medium"
                                name={selectedClient.name}
                              />
                            </div>
                            <div className="pr14">
                              <Heading>{selectedClient.name} </Heading>
                            </div>
                          </div>
                          <div className="fx mt-40">
                            {selectedClient.contractStartDate && (
                              <TextField
                                label="Contract StartDate"
                                value={selectedClient.contractStartDate}
                                customClassName="ml-0"
                              />
                            )}
                            {selectedClient.contractEndDate && (
                              <TextField
                                label="Contract EndDate"
                                value={selectedClient.contractEndDate}
                                customClassName="ml-0"
                              />
                            )}
                          </div>
                        </TextContainer>
                        <div className="pt25">
                          <Heading> Primary Contact Information </Heading>
                        </div>
                        {selectedClient.clientList &&
                          selectedClient.clientList.map((item) => {
                            return (
                              <FormLayout>
                                <TextField
                                  value={item.firstName}
                                  label="First Name"
                                  type="text"
                                />
                                <TextField
                                  value={item.lastName}
                                  label="Last Name"
                                  type="text"
                                />
                                <TextField
                                  value={item.phoneNumber}
                                  label="Phone"
                                  type="text"
                                />
                                <TextField
                                  label="Email"
                                  type="email"
                                  value={item.email}
                                />
                              </FormLayout>
                            );
                          })}
                      </div>
                    )}
                    <div data-qa="editBtn" className="Clients-Actions">
                      <ButtonGroup>
                        <DeleteModal
                          description={
                            'Are you sure you want to delete this client?'
                          }
                          handleDeleteConfirmation={() =>
                            this.deleteClient(selectedClient.accountId)
                          }
                          title="Delete client"
                        />
                        <Link
                          url={
                            '#/clients/editclient/' + selectedClient.accountId
                          }
                        >
                          <Button size="slim" secondary>
                            <Icon
                              style={{
                                width: 20,
                                height: 20,
                                color: '#0A0B10',
                                marginBottom: '6px',
                                cursor: 'pointer'
                              }}
                              icon={Edit}
                            />
                          </Button>
                        </Link>
                      </ButtonGroup>
                    </div>
                  </div>
                </ScrollContent>
              </RoleBoxContainer>
            )}
          </PageContent>
        </Card>
      </div>
    );
  }
}

export default injectIntl(ClientCascade);
